import { INDIA_MAP_DATA } from "../../pages/admin/dashboard/helper";
import { convertCamelCaseToDisplayText } from "../../utils";

/** @format */
export const HMR_RANGE_MAP = {
  "0-500": "0 to 500",
  "500-1000": "500 to 1000",
  "1000-1500": "1000 to 1500",
  "1500-2000": "1500 to 2000",
  "2000+": "Above 2000",
};

const monthOrder = [
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
  "january",
  "february",
  "march",
];

const DEFAULT_SUMARY_DATA = {
  topIssueCausing: [
    {
      label: "Part",
      data: "-",
      count: 0,
    },
    {
      label: "List",
      data: "-",
      count: 0,
    },
    {
      label: "Tickets OEM",
      data: "-",
      count: 0,
    },
  ],
  topModelHMR: [
    {
      label: "Model",
      data: "-",
      count: 0,
    },
    {
      label: "HMR",
      data: "-",
      count: 0,
    },
    {
      label: "State",
      data: "-",
      count: 0,
    },
  ],
};

export const formatReports = (response) => {
  let reportsData = {
    ticketSummaryCards: [],
    maxStateIssues: {},
    minStateIssue: {},
    ...DEFAULT_SUMARY_DATA,
  };
  if (response.partWiseCounts && response.partWiseCounts.length > 0) {
    const sortedPartWiseData = response.partWiseCounts.sort(
      (a, b) => b.count - a.count
    );
    reportsData.topIssueCausing[0] = {
      label: "Part",
      data: sortedPartWiseData[0].part,
      count: sortedPartWiseData[0].count,
    };
  }
  if (response.listNoWiseCounts && response.listNoWiseCounts.length > 0) {
    const sortedListWiseData = response.listNoWiseCounts.sort(
      (a, b) => b.count - a.count
    );
    reportsData.topIssueCausing[1] = {
      label: "List ",
      data: sortedListWiseData[0].listNo,
      count: sortedListWiseData[0].count,
    };
  }
  if (response.oemWiseCounts && response.oemWiseCounts.length > 0) {
    const oemWiseCountsData = response.oemWiseCounts.sort(
      (a, b) => b.count - a.count
    );
    reportsData.topIssueCausing[2] = {
      label: "Tickets OEM",
      data: oemWiseCountsData[0].name,
      count: oemWiseCountsData[0].count,
    };
  }

  if (
    response.engineModalWiseCounts &&
    response.engineModalWiseCounts.length > 0
  ) {
    const engineModalWiseCountsData = response.engineModalWiseCounts.sort(
      (a, b) => b.count - a.count
    );
    reportsData.topModelHMR[0] = {
      label: "Model",
      data: engineModalWiseCountsData[0].engineModal,
      count: engineModalWiseCountsData[0].count,
    };
  }

  if (
    response.hmrWiseCounts &&
    Object.keys(response.hmrWiseCounts || {}).length > 0
  ) {
    let name = "";
    let count = 0;

    Object.keys(response.hmrWiseCounts || {}).forEach((key) => {
      if (response.hmrWiseCounts[key] > count) {
        name = key;
        count = response.hmrWiseCounts[key];
      }
    });

    reportsData.topModelHMR[1] = {
      label: "HMR",
      data: HMR_RANGE_MAP[name],
      count: count,
    };
  }

  if (response?.stateWiseCounts2?.length > 0) {
    const { min, max } = response?.stateWiseCounts2?.reduce(
      (acc, item) => {
        if (item.count < acc.min.count) acc.min = item;
        if (item.count > acc.max.count) acc.max = item;
        return acc;
      },
      { min: response.stateWiseCounts2[0], max: response.stateWiseCounts2[0] } // Initialize with the first element
    );
    reportsData.maxStateIssue = max;
    reportsData.minStateIssue = min;

    // const validStates = response.stateWiseCounts.filter(
    //   (item) => item.name && item.name.trim()
    // );
    // const maxState = validStates.reduce((max, current) =>
    //   current.count > max.count ? current : max
    // );
    // reportsData.topModelHMR[2] = {
    //   label: "State",
    //   data: maxState.name,
    //   count: maxState.count,
    // };
  }

  reportsData.ticketSummaryCards = [
    {
      label: "Open",
      count: 10,
    },
    {
      label: "Without resolution",
      count: 12,
    },
    {
      label: "Reopened/Unresolved",
      count: 20,
    },
    {
      label: "Total tickets",
      count: 10,
    },
  ];

  return reportsData;
};

// export const formatIndiaMapData = (list, prevVal) => {
//   let newMapData = structuredClone(prevVal);
//   console.log(list, newMapData);
//   if (list?.length) {
//     list.forEach(({ state, count }) => {
//       console.log(newMapData[state]);
//       if (newMapData[state]) {
//         newMapData[state].value = count;
//       } else {
//         if (newMapData[state]) {
//           newMapData[state].value = 0;
//         }
//       }
//     });
//   } else {
//     newMapData = INDIA_MAP_DATA;
//   }

//   return newMapData;
// };

export const formatIndiaMapData = (list, prevVal) => {
  let newMapData = structuredClone(prevVal);

  if (list?.length) {
    // Create a Set of states present in the list
    const statesInList = new Set(list.map(({ state }) => state));

    list.forEach(({ state, count }) => {
      if (newMapData[state]) {
        newMapData[state].value = count;
      }
    });

    // Set value to 0 for states not present in the list
    Object.keys(newMapData).forEach((state) => {
      if (!statesInList.has(state)) {
        newMapData[state].value = 0;
      }
    });
  } else {
    newMapData = INDIA_MAP_DATA;
  }

  return newMapData;
};

export function getYearData(data) {
  const currentMonth = new Date()
    .toLocaleString("en-US", { month: "long" })
    .toLowerCase();

  const normalizedMonths = Object.keys(data.months || {}).reduce((acc, key) => {
    const monthData = data.months[key];
    // Extract replacementCount from the new structure, or use the value directly for old structure
    acc[key.toLowerCase()] =
      typeof monthData === "object" && monthData.replacementCount !== undefined
        ? monthData.replacementCount
        : monthData;
    return acc;
  }, {});

  const currentMonthIndex = monthOrder.indexOf(currentMonth);

  return monthOrder.map((month, index) => {
    if (normalizedMonths[month] !== undefined) {
      return normalizedMonths[month];
    } else if (index > currentMonthIndex) {
      // future month
      return "-";
    } else {
      // past month with no data
      return 0;
    }
  });
}
export function getYearData2(data) {
  const monthOrder = [
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december",
    "january",
    "february",
    "march",
  ];

  const currentMonth = new Date()
    .toLocaleString("en-US", { month: "long" })
    .toLowerCase();

  const normalizedMonths = Object.keys(data.months || {}).reduce((acc, key) => {
    const monthData = data.months[key];

    // If data structure is like { defect, defectCount, replacementCount }
    if (
      typeof monthData === "object" &&
      monthData.replacementCount !== undefined
    ) {
      acc[key.toLowerCase()] = {
        value: monthData.replacementCount,
        defect: monthData.defect || "N/A",
        defectCount: monthData.defectCount || 0,
      };
    } else {
      // Backward-compatible with old data structures
      acc[key.toLowerCase()] = {
        value: typeof monthData === "number" ? monthData : 0,
        defect: "N/A",
        defectCount: 0,
      };
    }

    return acc;
  }, {});

  const currentMonthIndex = monthOrder.indexOf(currentMonth);

  return monthOrder.map((month, index) => {
    if (normalizedMonths[month] !== undefined) {
      return normalizedMonths[month];
    } else if (index > currentMonthIndex) {
      // Future month
      return { value: null, defect: null, defectCount: null };
    } else {
      // Past month with no data
      return { value: 0, defect: null, defectCount: null };
    }
  });
}

export const ENG_DETAILS_STATE = (data = {}) => {
  const predefinedColors = ["#FF5151", "#FFC002", "#0270C0", "#02B050"]; // Define colors for each year
  const yearTotals = Object.entries(data).map(([year, details]) => {
    const totalCount =
      details.total ||
      Object.values(details.months).reduce((sum, monthData) => {
        if (
          typeof monthData === "object" &&
          monthData.replacementCount !== undefined
        ) {
          return sum + monthData.replacementCount;
        }
        return sum + (typeof monthData === "number" ? monthData : 0);
      }, 0);
    return { year, totalCount };
  });

  const yearCountList = yearTotals?.map((ele) => ele.totalCount) || [];
  const yearList = yearTotals?.map((ele) => ele.year) || [];

  const yearMonthsData =
    Object.entries(data).map(([year, details], index) => {
      const monthData = getYearData(details);
      const nullArray = new Array(yearList.length).fill(null);
      return {
        name: year,
        type: "line",
        data: [
          ...nullArray,
          ...monthData.map((val) => (val === "-" ? null : Number(val))),
        ],
        color: predefinedColors[index % predefinedColors.length],
      };
    }) || [];

  return {
    series: [
      {
        name: "Count in year",
        type: "column",
        data: yearCountList,
      },
      ...yearMonthsData,
    ],
    options: {
      colors: [
        function ({ value, seriesIndex }) {
          if (seriesIndex === 0 && value !== undefined) {
            switch (value) {
              case yearCountList[0]:
                return predefinedColors[0];
              case yearCountList[1]:
                return predefinedColors[1];
              case yearCountList[2]:
                return predefinedColors[2];
              case yearCountList[3]:
                return predefinedColors[3];
              default:
                return "#000000"; // Default color
            }
          } else if (seriesIndex > 0) {
            switch (seriesIndex) {
              case 1:
                return predefinedColors[0];
              case 2:
                return predefinedColors[2];
              case 3:
                return predefinedColors[3];
              case 4:
                return predefinedColors[4];
              default:
                return "#000000"; // Default color
            }
          }
          return "#000000"; // Fallback color
        },
      ],

      chart: {
        type: "bar",
      },
      stroke: {
        width: [0, 4], // Bar has width 0, lines have width 4
        curve: "smooth",
      },

      title: {
        text: "",
      },

      dataLabels: {
        enabled: true,
        enabledOnSeries: [0], // Enable data labels only for the bar chart,
      },
      labels: [
        ...yearList,
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
        "JAN",
        "FEB",
        "MAR",
      ],

      yaxis: [
        {
          title: {
            text: "Year Count",
          },
        },
        {
          opposite: true,
          title: {
            text: "Month Count",
          },
        },
      ],
      legend: {
        show: false,
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const value = series[seriesIndex][dataPointIndex];
          if (value === null) {
            return "";
          }

          const category = w.globals.categoryLabels[dataPointIndex];

          // For bar series
          if (seriesIndex === 0) {
            return `<div >
                        <div style="background:#e8e7e6; padding:5px ">${category}</div>
                        <div style="padding:5px 10px">Count in year: ${value}</div>
                    </div>`;
          }

          // For line series
          const year = w.globals.seriesNames[seriesIndex];

          const month = w.globals.labels[dataPointIndex];
          const monthLabel = w.globals.categoryLabels[dataPointIndex];

          const removeExtraLength = series[seriesIndex].length - 12;
          const currentMonth = monthOrder[month - removeExtraLength - 1];
          const monthData =
            data[year]?.months[capitalizeFirstLetter(currentMonth)];

          let customDataHtml = "";
          if (typeof monthData === "object" && monthData !== null) {
            for (const key in monthData) {
              if (key !== "replacementCount") {
                customDataHtml += `<div style="margin-bottom:4px"><b style="color:#1e3b85; "> ${
                  key === "defect"
                    ? "Top Defect"
                    : convertCamelCaseToDisplayText(key)
                }:</b> ${monthData[key]}</div>`;
              }
            }
          }

          return `<div style="">
                    <div style="background:#e8e7e6; padding:5px "><b>${year} - ${monthLabel}</b></div>
                   <div style="padding:5px 10px">
                    <div style="margin-bottom:4px"><b style="color:#1e3b85; ">Count:</b> ${value}</div>
                    ${customDataHtml}
                    </div>
                </div>`;
        },
      },
    },
  };
};

function capitalizeFirstLetter(str) {
  if (typeof str !== "string" || str.length === 0) {
    return ""; // Handle empty or non-string inputs
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const CURRENT_ENG_DETAILS_STATE = {
  series: [
    {
      name: "2022-2023",
      type: "column",
      data: [],
    },
    {
      name: "Count In Each Month",
      type: "line",
      data: [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
      ],
    },
  ],
  options: {
    colors: ["#000000"],
    chart: {
      height: 450,
      type: "line",
    },
    stroke: {
      width: [0, 4],
    },
    title: {
      text: "",
    },
    plotOptions: {
      bar: { columnWidth: "70%", distributed: true, barHeight: "85%" },
      line: { columnWidth: "70%", distributed: true, barHeight: "85%" },
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [0],
    },
    labels: [
      "2022-2023",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
      "JAN",
      "FEB",
      "MAR",
    ],
    yaxis: [
      {
        title: {
          text: "Count",
        },
      },
      {
        opposite: true,
        title: {
          text: "Counts",
        },
      },
    ],
    legend: {
      show: false,
    },
  },
};

export const CUR_MONTH_INDX = {
  APR: 1,
  MAY: 2,
  JUN: 3,
  JUL: 4,
  AUG: 5,
  SEP: 6,
  OCT: 7,
  NOV: 8,
  DEC: 9,
  JAN: 10,
  FEB: 11,
  MAR: 12,
};

export const formatAllInfoResponse = (allInfo) => {
  if (
    allInfo &&
    allInfo.engineModalWiseCounts &&
    allInfo.engineModalWiseCounts.length > 0
  ) {
    allInfo.engineModalWiseCounts = allInfo.engineModalWiseCounts.sort((a, b) =>
      (a.engineModal || "").localeCompare(b.engineModal, "en", {
        numeric: true,
      })
    );
  }

  return allInfo;
};
